export const styles = (theme) => {
  return {
    tableHead: {
      backgroundColor: theme.palette.colors.yellow300,
      color: theme.palette.colors.black70,
      fontWeight: "bold"
    },
    tableHeadCell: {
      fontWeight: "inherit"
    },
    tableCell: {
      borderBottom: "solid 1px darkGrey",
      backgroundColor: "white"
    },
    itemActionButton: {
      margin: theme.spacing(1),
      color: theme.palette.colors.black70,
      backgroundColor: theme.palette.colors.yellow300,
      padding: theme.spacing(0.75)
    },

    reorderButton: {
      margin: theme.spacing(1),
      padding: theme.spacing(0.75)
    },
    tableRow: {
      //backgroundColor: "grey"
    },

    actionButton: {
      backgroundColor: theme.palette.colors.yellow300,
      marginBottom: theme.spacing(2),
      marginRight: theme.spacing(1)
    },
    searchField: {
      margin: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
      width: "-webkit-fill-available"
    },
    searchBarContainer: {
      marginBottom: theme.spacing(2)
    }
  };
};
